module.exports = __webpack_public_path__ + "media/images/products-img-06-8fe537e685506c771f629c25474b0cdd.jpg";